import { cn } from "../../../lib/cn";

/** Smooth CTA feedback without animating gradient stops (avoids `h-auto` reflow). */
export const CTA_SURFACE_TRANSITION_CLASS =
	"transition-[box-shadow,filter,ring-color] duration-200 ease-out motion-reduce:transition-none";

/** Primary amber CTA elevation — warm glow + inset highlight. */
export const CTA_PRIMARY_ELEVATION_CLASS = cn(
	"shadow-[0_1px_2px_rgb(15_23_42/0.1),0_4px_14px_rgb(217_152_0/0.28)]",
	"ring-1 ring-inset ring-white/35",
	"hover:shadow-[0_2px_6px_rgb(15_23_42/0.12),0_10px_26px_rgb(217_152_0/0.38)]",
	"hover:brightness-[1.04]",
	"active:shadow-[0_1px_2px_rgb(15_23_42/0.14)]",
	"active:brightness-[0.97]",
	CTA_SURFACE_TRANSITION_CLASS,
);

/** Compact primary CTA shadow (micro / small sizes). */
export const CTA_PRIMARY_ELEVATION_COMPACT_CLASS = cn(
	"shadow-[0_1px_2px_rgb(15_23_42/0.08),0_3px_10px_rgb(217_152_0/0.22)]",
	"ring-1 ring-inset ring-white/30",
	"hover:shadow-[0_2px_4px_rgb(15_23_42/0.1),0_6px_16px_rgb(217_152_0/0.3)]",
	"hover:brightness-[1.04]",
	"active:shadow-[0_1px_2px_rgb(15_23_42/0.12)]",
	"active:brightness-[0.97]",
	CTA_SURFACE_TRANSITION_CLASS,
);

/** Secondary neutral CTA elevation — crisp edge + soft depth. */
export const CTA_SECONDARY_ELEVATION_CLASS = cn(
	"shadow-[0_1px_2px_rgb(15_23_42/0.08),0_3px_10px_rgb(15_23_42/0.06)]",
	"ring-1 ring-inset ring-white/50 dark:ring-white/12",
	"hover:shadow-[0_2px_5px_rgb(15_23_42/0.1),0_8px_20px_rgb(15_23_42/0.09)]",
	"hover:brightness-[1.02] dark:hover:brightness-[1.06]",
	"active:shadow-[0_1px_2px_rgb(15_23_42/0.12)]",
	"active:brightness-[0.98] dark:active:brightness-[0.94]",
	CTA_SURFACE_TRANSITION_CLASS,
);

/** Destructive red CTA elevation — warm glow + inset highlight. */
export const CTA_DESTRUCTIVE_ELEVATION_CLASS = cn(
	"shadow-[0_1px_2px_rgb(15_23_42/0.1),0_4px_14px_rgb(194_61_0/0.28)]",
	"ring-1 ring-inset ring-white/35",
	"hover:shadow-[0_2px_6px_rgb(15_23_42/0.12),0_10px_26px_rgb(194_61_0/0.38)]",
	"hover:brightness-[1.04]",
	"active:shadow-[0_1px_2px_rgb(15_23_42/0.14)]",
	"active:brightness-[0.97]",
	CTA_SURFACE_TRANSITION_CLASS,
);

/** Compact destructive CTA shadow (micro / small sizes). */
export const CTA_DESTRUCTIVE_ELEVATION_COMPACT_CLASS = cn(
	"shadow-[0_1px_2px_rgb(15_23_42/0.08),0_3px_10px_rgb(194_61_0/0.22)]",
	"ring-1 ring-inset ring-white/30",
	"hover:shadow-[0_2px_4px_rgb(15_23_42/0.1),0_6px_16px_rgb(194_61_0/0.3)]",
	"hover:brightness-[1.04]",
	"active:shadow-[0_1px_2px_rgb(15_23_42/0.12)]",
	"active:brightness-[0.97]",
	CTA_SURFACE_TRANSITION_CLASS,
);
